const formatOptionParentKey = (key: string): string => {
  const formattedKey = key.replace(/_/g, ' ').toLowerCase();
  return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
};

export default formatOptionParentKey;
